import { render, staticRenderFns } from "./BtRaisedChart.vue?vue&type=template&id=b89a8cde&scoped=true&"
import script from "./BtRaisedChart.vue?vue&type=script&lang=js&"
export * from "./BtRaisedChart.vue?vue&type=script&lang=js&"
import style0 from "./BtRaisedChart.vue?vue&type=style&index=0&id=b89a8cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89a8cde",
  null
  
)

export default component.exports